import update from "immutability-helper";

import { type Action, handleActions } from "redux-actions";
import { type IGuestlistState } from "../../guestlist/model";
import { Actions } from "../actions/actions";

export const initialState: IGuestlistState = {
  error: false,
  guestlist: null,
  guestsState: {
    error: false,
    guests: null,
    hasData: false,
    loading: true
  },
  hasData: false,
  loading: true,
  modals: {
    guestAddingState: {
      editedGuest: null,
      errors: [],
      isLoading: false,
      showModal: false
    },
    guestlistDeletionState: {
      showModal: false
    },
    guestlistSettingsState: {
      errors: [],
      isLoading: false
    },
    placeManagementState: {
      currentEdited: null,
      errors: [],
      isLoading: false,
      showDeleteModal: false,
      showModal: false
    }
  },
  permission: {
    hasFullAccess: false
  },
  searchState: {
    searchQuery: ""
  },
  showId: 0
};

const reducer = handleActions<IGuestlistState, any>({
  [Actions.Guestlist.GUESTLIST_REQUEST]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      loading: { $set: true }
    });

    return newState;
  },
  [Actions.Guestlist.GUESTLIST_FAILURE]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      error: { $set: true },
      loading: { $set: false }
    });

    return newState;
  },
  [Actions.Guestlist.GUESTLIST_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const newState = update(state, {
      guestlist: { $set: action.payload.data },
      loading: { $set: false },
      permission: { $set: action.payload.permission }
    });

    return newState;
  },
  [Actions.Guestlist.GUESTLIST_SETTINGS_SHOW]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestlistSettingsState: {
          errors: { $set: [] }
        },
        placeManagementState: {
          currentEdited: { $set: null },
          errors: { $set: [] },
          showModal: { $set: true }
        }
      }
    });

    return newState;
  },
  [Actions.Guestlist.GUESTLIST_SETTINGS_HIDE]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestlistSettingsState: {
          errors: { $set: [] }
        },
        placeManagementState: {
          currentEdited: { $set: null },
          errors: { $set: [] },
          showModal: { $set: false }
        }
      }
    });

    return newState;
  },
  [Actions.Guestlist.GUEST_ADDING_MODAL_SHOW]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestAddingState: {
          editedGuest: { $set: action.payload },
          showModal: { $set: true }
        }
      }
    });
    return newState;
  },
  [Actions.Guestlist.GUEST_ADDING_MODAL_HIDE]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestAddingState: {
          errors: { $set: [] },
          showModal: { $set: false }
        }
      }
    });

    return newState;
  },
  [Actions.Guestlist.GUEST_ADD_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      guestAddingState: {
        isLoading: { $set: true }
      }
    }
  }),
  [Actions.Guestlist.GUEST_ADD_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const result = action.payload;

    return update(state, {
      modals: {
        guestAddingState: {
          errors: { $set: result.errors },
          isLoading: { $set: false }
        }
      }
    });
  },
  [Actions.Guestlist.GUEST_ADD_FAILURE]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestAddingState: {
          errors: { $set: [{ code: 0, message: "Server erroActions.Guestlist... try again later" }] },
          isLoading: { $set: false }
        }
      }
    });
    return newState;
  },
  [Actions.Guestlist.GUEST_UPDATE_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      guestAddingState: {
        isLoading: { $set: true }
      }
    }
  }),
  [Actions.Guestlist.GUEST_UPDATE_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const result = action.payload;
    return update(state, {
      modals: {
        guestAddingState: {
          errors: { $set: result.errors },
          isLoading: { $set: false }
        }
      }
    });
  },
  [Actions.Guestlist.GUEST_UPDATE_FAILURE]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestAddingState: {
          errors: { $set: [{ code: 0, message: "Server erroActions.Guestlist... try again later" }] },
          isLoading: { $set: false }
        }
      }
    });
    return newState;
  },
  [Actions.Guestlist.SET_SHOW_ID]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const newState = update(state, {
      showId: { $set: +action.payload }
    });

    return newState;
  },
  [Actions.Guestlist.GUESTLIST_UPDATE_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      guestlistSettingsState: {
        isLoading: { $set: true }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_UPDATE_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const result = action.payload;
    return update(state, {
      modals: {
        guestlistSettingsState: {
          errors: { $set: result.errors },
          isLoading: { $set: false }
        }
      }
    });
  },
  [Actions.Guestlist.GUESTLIST_UPDATE_FAILURE]: (state: IGuestlistState): IGuestlistState => {
    const newState = update(state, {
      modals: {
        guestlistSettingsState: {
          errors: { $set: [{ code: 0, message: "Server erroActions.Guestlist... try again later" }] },
          isLoading: { $set: false }
        }
      }
    });

    return newState;
  },
  [Actions.Guestlist.GUESTLIST_PLACE_EDIT_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      placeManagementState: {
        isLoading: { $set: true }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_PLACE_EDIT_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    return update(state, {
      modals: {
        placeManagementState: {
          errors: { $set: action.payload.errors },
          isLoading: { $set: false }
        }
      }
    });
  },
  [Actions.Guestlist.GUESTLIST_PLACE_EDIT_FAILURE]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      placeManagementState: {
        isLoading: { $set: false }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_PLACE_ADD_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      placeManagementState: {
        isLoading: { $set: true }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_PLACE_ADD_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    return update(state, {
      modals: {
        placeManagementState: {
          errors: { $set: action.payload.errors },
          isLoading: { $set: false }
        }
      }
    });
  },
  [Actions.Guestlist.GUESTLIST_PLACE_ADD_FAILURE]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      placeManagementState: {
        isLoading: { $set: false }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_PLACE_REMOVE_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    modals: {
      placeManagementState: {
        isLoading: { $set: true }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_PLACE_REMOVE_SUCCESS]: (state: IGuestlistState, action: Action<any>): IGuestlistState => update(state, {
    modals: {
      placeManagementState: {
        errors: { $set: action.payload.errors },
        isLoading: { $set: false }
      }
    }
  }),
  [Actions.Guestlist.GUESTLIST_DELETE_REQUEST]: (state: IGuestlistState): IGuestlistState => update(state, {
    loading: {
      $set: true
    }
  }),
  [Actions.Guestlist.GUESTLIST_DELETE_SUCCESS]: (state: IGuestlistState): IGuestlistState => update(initialState, {
    loading: { $set: false },
    showId: { $set: state.showId }
  }),
  [Actions.Guestlist.GUESTLIST_DELETE_FAILURE]: (state: IGuestlistState): IGuestlistState => update(state, {
    loading: {
      $set: false
    }
  }),
  [Actions.Guestlist.SET_CURRENT_EDITED_GUESTLIST_PLACE]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const newState = update(state, {
      modals: {
        placeManagementState: {
          currentEdited: { $set: action.payload },
          errors: { $set: [] }
        }
      }
    });

    return newState;
  },
  [Actions.Guestlist.SET_SHOW_DELETE_MODAL]: (state: IGuestlistState, action: Action<boolean>): IGuestlistState => {
    const newState = update(state, {
      modals: {
        placeManagementState: {
          showDeleteModal: { $set: action.payload }
        }
      }
    });

    return newState;
  },
  [Actions.Guestlist.SET_SEARCH_STATE]: (state: IGuestlistState, action: Action<any>): IGuestlistState => {
    const newState = update(state, {
      searchState: {
        searchQuery: { $set: action.payload }
      }
    });

    return newState;
  },
  [Actions.Guestlist.SET_GUESTLIST_DELETE_MODAL]: (state: IGuestlistState, action: Action<boolean>): IGuestlistState => update(state, {
    modals: {
      guestlistDeletionState: {
        showModal: { $set: action.payload }
      }
    }
  })
}, initialState);

export default reducer;
